import { SBState } from "@bookingcom/flights-searchbox";

export type State = SBState | undefined;

export const getInitialState = (): State => ({} as SBState);
